import { defineRecipe } from '@chakra-ui/react';

export const recipe = defineRecipe({
  base: {
    bg: { _light: 'white', _dark: 'whiteAlpha.50' },
    shadow: 'card',
    borderRadius: 'base',
  },
});
